
function ToursEn() {

    return (
        <div>
            <main>
                <section>
                    <div className="banner">
                        <img className='header-image' src="/assets/city-img/tour_banner.JPG" alt="" />
                    </div>
                </section>
                <div className="content">
                    <article>
                        <div className="text">
                            <h1>Tours in and around Wismar</h1>
                            <p>There is a lot to discover not only in Apartment 5 but also around it. A city 
                                tour, bike ride or restaurant tour - great experiences await you in little Wismar.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Sightseeing Tour</h2>
                            <p>Whether as a guided tour of the city, on your own or in the comfort of a sightseeing tour - 
                                Wismar and its buildings can be explored and discovered in a variety of ways.<br></br>
                                In addition to the classic public city tour, there is also the night watchman tour, 
                                which presents the Hanseatic city in an evening atmosphere. If you prefer a themed tour, 
                                try the SOKO Wismar city tour, based on the filming locations and crime scenes of the 
                                popular crime series, or the Nosferatu tour, which follows in the footsteps of the 
                                classic scary film.<br></br>The convertible double-decker bus is also available 
                                for sightseeing tours, making airy sightseeing fun possible without tired feet. The somewhat 
                                different nostalgic tour can be experienced in the American yellow school bus, which winds 
                                its way through even the smallest side streets. For all those who have always wondered when 
                                watching US films what it would feel like to ride in one.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Cycling tours</h2>
                            <p>Probably the most beautiful way to discover Wismar's surrounding countryside. Either on the 
                                bikes you have brought with you or on rental bikes from Wismar's city centre. Let the North 
                                German breeze blow around your nose as you pedal and let your gaze wander over the breathtaking 
                                expanses of the Mecklenburg countryside.<br></br>Here too, are are a wide variety of themed 
                                tours to choose from, along the Bay of Wismar, in the north and west of Wismar or a little 
                                further afield to discover castles and fortresses by bike. Not forgetting the island of Poel, 
                                which is not only ideal for beach excursions.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Boat tours</h2>
                            <p>What could be better on the Baltic Sea than a tour on the water? A classic harbour cruise to 
                                explore Wismar from the seaward side, or to sail to the Poel peninsula and spend one of the 
                                popular beach days there. For that historic feeling, it's best to hire on the Poeler Kogge, 
                                an original replica from the Middle Ages.<br></br>If you prefer something more active, take 
                                a pedalo or book a speedboat tour to the grey seals on the seal bank.
                            </p>
                        </div>
                    </article>
                </div>
            </main>
        </div>
    )
}

export default ToursEn;